import React from 'react';
import { Globe } from 'lucide-react';
import DataSection from '../dataSections/DataSection';

export default function Gdelt() {
  return (
    <DataSection
      title="GDELT"
      icon={Globe}
      contentType="gdelt"
      executionUrlSuffix="gdelt"
    />
  );
}

